import { Moment } from 'moment'

import { Descriptive, Labeled } from '../base'
import { Campaign } from './campaign'
import { Client } from './client'
import { Contact } from './contact'
import { Formatset } from './formatset'
import { Comment } from './comment'
import moment from 'moment'

export type ProjectId = string
export type ProjectStatus = Descriptive
export type ProjectAction = Descriptive
export type Project = {
  id: ProjectId
  name: string
  status: ProjectStatus
  campaigns: Campaign[]
  possibleActions: ProjectAction[]
  nextAction?: ProjectAction
  contacts: Contact[]
  pmContacts: Contact[]
  deadline: Moment
  client: Client
  comment: Comment | null
  formatsets: Formatset[]
  creativeStates: Labeled[]
  isFavorite: boolean
  message: string | null
}
export type UnsavedProjectType = {
  name: string
  campaigns: Campaign[]
  contacts: Contact[]
  pmContacts: Contact[]
  deadline: Moment
  client: Client | null
}

export const unsavedProject: () => UnsavedProjectType = () => {
  return {
    name: '',
    campaigns: [],
    contacts: [],
    pmContacts: [],
    deadline: moment().add(2, 'weeks'),
    client: null,
  }
}

export function isSavedProject(
  project: Project | UnsavedProjectType,
): project is Project {
  return 'id' in project
}

export function isProjectId(project: any): project is ProjectId {
  return typeof project === 'string'
}
